import { FormattedMessage } from 'react-intl'
import Chip from '@mui/material/Chip'
import CircularProgress from '@mui/material/CircularProgress'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { getDeploymentStatus, getDeploymentStatusColor } from '../utils/deployment/deploymentStatus'

function DeploymentStatusChip({ deployment, showName = false, showIcon = false }) {
  const status = getDeploymentStatus(deployment)

  if (!status) return null

  const isDeployed = status === 'deployed'
  const color = getDeploymentStatusColor(status)

  const label = showName
    ? deployment.name
    : <FormattedMessage id={`deployments.status.${status}`} />

  const icon = showIcon
    ? (isDeployed ? <CheckCircleIcon /> : <CircularProgress size={16} color="inherit" />)
    : undefined

  return (
    <Chip
      label={label}
      size="small"
      color={color}
      icon={icon}
      variant={showIcon ? 'outlined' : 'filled'}
    />
  )
}

export default DeploymentStatusChip
